// extracted by mini-css-extract-plugin
module.exports = {"doneButton":"viewResourceModal_doneButton__1N-KT"};